<template>
  <div class="dd-page">
    <header class="dd-header">
      <strong>STAR-SDD Installer取得</strong
      ><button v-if="user" @click="logout">ログアウト</button>
    </header>
    <main class="dd-main">
      <div class="dd-title">
        <div>
          <h1>Installerの取得</h1>
          <p>
            登録済みの利用ユーザでログインすると、取得可能な版だけを表示します。
          </p>
        </div>
        <div v-if="user">
          {{ user.display_name
          }}<small>{{ user.company_name }} / {{ types[user.user_type] }}</small>
        </div>
      </div>
      <p v-if="error" role="alert" class="dd-message error">{{ error }}</p>
      <p v-if="message" role="status" class="dd-message">{{ message }}</p>
      <section v-if="!user" class="dd-panel dd-login">
        <h2>利用ユーザログイン</h2>
        <form @submit.prevent="login">
          <label
            >ログインID<input
              v-model="credentials.username"
              required
              autocomplete="username" /></label
          ><label
            >パスワード<input
              v-model="credentials.password"
              required
              type="password"
              autocomplete="current-password" /></label
          ><button type="submit" :disabled="busy">
            {{ busy ? '確認中…' : 'ログイン' }}
          </button>
        </form>
      </section>
      <template v-else
        ><section class="dd-panel">
          <form class="dd-grid" @submit.prevent="load">
            <label
              >対象構成<select v-model="filters.configuration" @change="clear">
                <option>SA</option>
                <option>CS</option>
              </select></label
            ><label
              >配布区分<select v-model="filters.install_kind" @change="clear">
                <option value="IN">初回導入</option>
                <option value="UP">本体更新</option>
              </select></label
            ><label v-if="filters.install_kind === 'UP'"
              >現在の製品Version・Build<input
                v-model="filters.current_release"
                required
                placeholder="1.1.2_20261029_2"
                @input="clear" /></label
            ><label
              >OS<select v-model="filters.target_os" @change="clear">
                <option value="windows">Windows</option>
                <option value="linux">Linux</option>
                <option value="macos">macOS</option>
              </select></label
            ><label
              >アーキテクチャ<select
                v-model="filters.target_arch"
                @change="clear"
              >
                <option>x64</option>
                <option>arm64</option>
              </select></label
            >
            <div style="align-self: end">
              <button type="submit" :disabled="busy">取得可能な版を表示</button>
            </div>
          </form>
        </section>
        <section class="dd-panel">
          <h2>取得可能なInstaller</h2>
          <p class="dd-note">
            対象の正式最新版：{{ latest ? latest.docker_version : '対象なし' }}
          </p>
          <div class="dd-table-wrap">
            <table>
              <thead>
                <tr>
                  <th>選択</th>
                  <th>区分</th>
                  <th>Version</th>
                  <th>リリース日</th>
                  <th>説明</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in rows" :key="row.docker_id">
                  <td>
                    <input
                      v-model="selected"
                      type="radio"
                      :value="row.docker_id"
                      name="installer"
                      :aria-label="row.docker_version"
                    />
                  </td>
                  <td>
                    <span :class="['dd-badge', row.publication_status]">{{
                      statuses[row.publication_status]
                    }}</span>
                  </td>
                  <td>{{ row.docker_version }}</td>
                  <td>{{ row.release_date }}</td>
                  <td>{{ row.docker_info }}</td>
                  <td>
                    <button class="secondary" @click="showDetail(row)">
                      詳細
                    </button>
                  </td>
                </tr>
                <tr v-if="!rows.length">
                  <td colspan="6" class="dd-empty">
                    {{ busy ? '確認中…' : '取得可能なInstallerはありません' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dd-actions">
            <button :disabled="busy || !selected" @click="download">
              ダウンロード
            </button>
          </div>
          <p class="dd-native-note">
            取得完了とインストール完了は別です。この画面から自動インストールは行いません。
          </p>
        </section>
        <section v-if="detail" class="dd-panel">
          <h2>バージョン詳細</h2>
          <dl class="dd-detail">
            <dt>Version</dt>
            <dd>{{ detail.docker_version }}</dd>
            <dt>ファイル名</dt>
            <dd>{{ detail.file_name }}</dd>
            <dt>ダウンロード名</dt>
            <dd>{{ detail.download_name }}</dd>
            <dt>サイズ</dt>
            <dd>{{ detail.file_size }} bytes</dd>
            <dt>SHA-256</dt>
            <dd>
              <code>{{ detail.sha256 }}</code>
            </dd>
            <dt>対象Block</dt>
            <dd>{{ detail.module_ids.join(', ') || '全体配布' }}</dd>
            <dt>リリースノート</dt>
            <dd>{{ detail.release_notes || '記載なし' }}</dd>
          </dl>
          <button class="secondary" @click="detail = null">閉じる</button>
        </section></template
      >
    </main>
  </div>
</template>
<script>
import api from '../api';
import { userTypes, statuses } from '../fields';
export default {
  name: 'UserUpdateView',
  data() {
    return {
      user: null,
      types: userTypes,
      statuses,
      credentials: { username: '', password: '' },
      filters: {
        configuration: 'SA',
        install_kind: 'IN',
        current_release: '',
        target_os: 'windows',
        target_arch: 'x64',
      },
      rows: [],
      latest: null,
      selected: null,
      detail: null,
      busy: false,
      error: '',
      message: '',
    };
  },
  async created() {
    try {
      this.user = (await api.get('/api/auth/me')).data.user;
      await this.load();
    } catch (e) {
      if (e.response?.status !== 401)
        this.error = e.response?.data?.error || '認証状態を確認できません';
    }
  },
  beforeUnmount() {
    this.credentials.password = '';
  },
  methods: {
    clear() {
      this.rows = [];
      this.latest = null;
      this.selected = null;
      this.detail = null;
      this.message = '';
    },
    params() {
      const p = { ...this.filters };
      if (p.install_kind !== 'UP') delete p.current_release;
      return p;
    },
    async login() {
      if (this.busy) return;
      this.busy = true;
      this.error = '';
      try {
        this.user = (
          await api.post('/api/auth/login', {
            ...this.credentials,
            client_type: 'web',
          })
        ).data.user;
        this.credentials.password = '';
        this.clear();
        await this.load();
      } catch (e) {
        this.error = e.response?.data?.error || 'ログインに失敗しました';
      } finally {
        this.credentials.password = '';
        this.busy = false;
      }
    },
    handleError(e) {
      this.error = e.response?.data?.error || '取得情報を確認できません';
      this.clear();
      if ([401, 403].includes(e.response?.status)) this.user = null;
    },
    async load() {
      this.clear();
      this.busy = true;
      this.error = '';
      try {
        const [list, latest] = await Promise.all([
          api.get('/api/installers', { params: this.params() }),
          api.get('/api/installers/latest', { params: this.params() }),
        ]);
        this.rows = list.data;
        this.latest = latest.data;
      } catch (e) {
        this.handleError(e);
      } finally {
        this.busy = false;
      }
    },
    async showDetail(row) {
      this.error = '';
      try {
        this.detail = (
          await api.get('/api/installers/' + row.docker_id, {
            params: this.params(),
          })
        ).data;
      } catch (e) {
        this.handleError(e);
      }
    },
    async download() {
      if (!this.selected || this.busy) return;
      this.error = '';
      try {
        const item = (
          await api.get('/api/installers/' + this.selected, {
            params: this.params(),
          })
        ).data;
        const q = new URLSearchParams(this.params());
        const a = document.createElement('a');
        a.href =
          (api.defaults.baseURL || '') +
          `/api/installers/${item.docker_id}/download?${q}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        this.message = `ダウンロードを開始しました。ブラウザーの保存結果を確認してください。\n取得時の名前：${item.download_name}\n照合用SHA-256：${item.sha256}\n実更新：未実施`;
        if (item.download_name !== item.file_name)
          this.message += `\n実行時はファイル名を ${item.file_name} に戻してください。`;
      } catch (e) {
        this.handleError(e);
      }
    },
    async logout() {
      try {
        await api.post('/api/auth/logout', {});
      } finally {
        this.user = null;
        this.credentials.password = '';
        this.clear();
      }
    },
  },
};
</script>
